import { render } from "./FileSgpm.vue?vue&type=template&id=2976eb88"
import script from "./FileSgpm.vue?vue&type=script&lang=ts"
export * from "./FileSgpm.vue?vue&type=script&lang=ts"
script.render = render

export default script